export default "__VITE_ASSET__CUcP41M9__"